import React, { useEffect, useState } from "react";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { useStores } from "../../store/index";
import { Observer } from "mobx-react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { MdDownload } from "react-icons/md";
import LearningModule from "./learnModule";
import { getIdbyUrl, isParamExist } from "../../services/reusable";
import { FaBars } from "react-icons/fa"; // Import the menu icon
// import { logoUrl } from "../../helpers/constantVariables";
import CourseProgress from "./courseProgress";
import { learnBenefits } from "../../helpers/learnBenefits";
import { TiTick } from "react-icons/ti";
import { BiChevronDownCircle, BiChevronUpCircle } from "react-icons/bi";
import { BsDot } from "react-icons/bs";
import { courseOutcomes } from "../../helpers/courseOutcomes";
import HelpCenter from "../reusble_components/helpCenter";
import { toJS } from "mobx";
import CourseCertificate from "../certificate/CourseCertificate";
import queryString from "query-string";
import { getLogoBySubdomain } from "../../services/white_label";
import Popup from "../reusble_components/popup";
import { loginWarningImage } from "../../helpers/constantVariables";
import { setDataToLocalStorage } from "../../services/localStorage";
import LoadingAnime from "../reusble_components/loadingAnime";
export default function LearninngTab(hide) {
  const navigate = useNavigate();
  const { LearningStore, UserStore, PopupStore, CommonStore } = useStores();
  const [onBreak, setonBreak] = useState(false); // this will be true when it's in mobile view
  const [collapse, setCollapse] = useState(false);
  const [toggled, setToggled] = React.useState(false);
  const toggleCollapse = () => {
    setCollapse(!collapse);
  };

  const getTheQueryFromUrl = (queryId) => {
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get(queryId);
    return myParam;
  };

  const getCourseById = () => {
    const courseId = getIdbyUrl();
    LearningStore.setCurrentCourseId(courseId);
    LearningStore.getCourseFromServer(courseId, getTheQueryFromUrl("topic"));
    LearningStore.setHittendApis("currentCourse", true);
  };

  const getAllApis = () => {
    getCourseById();

    const userDetails = JSON.parse(localStorage.getItem("user"));
    console.log("userDetails", userDetails?._id);
    LearningStore.getEnrolledCoursesFromServer(userDetails?._id);
    UserStore.getUserDetails();
    LearningStore.getCourseListFromApi();
    console.log("userDetailas", userDetails);

    UserStore.fetchDashboardInterviews();
  };

  useEffect(() => {
    console.log("useEffect");
    LearningStore.setHittendApis("currentCourse", false);
    getAllApis();

    CommonStore.setShowHeaderInDashboard(false);
    CommonStore.setCollapse(true);

    // console.log("width of window", window.innerWidth);

    return () => {
      try {
        LearningStore.setCurrentCourseId(null);
        LearningStore.setCurrentCourse(null);
        LearningStore.setallSubtopics([]);
        CommonStore.setShowHeaderInDashboard(true);

        // LearningStore.setHittendApis("currentCourse", false);
      } catch (error) {
        console.log("error", error);
      }
    };
  }, []);

  const toggleTheSideBarAsPerBreakPoint = () => {
    if (onBreak) {
      setToggled(!toggled);
    } else {
      setCollapse(!collapse);
    }
  };

  const closeSideBar = () => {
    setToggled(false);
  };

  const header = (course) => {
    return (
      <header className="bg-white min-h-[60px] flex flex-col justify-center py-2 gil-reg shadow-lg">
        <div className="flex items-center justify-between mx-5">
          <div className="flex flex-row items-center">
            <button
              className="text-white text-2xl focus:outline-none hidden"
              onClick={toggleTheSideBarAsPerBreakPoint}
            >
              <FaBars className="text-black" />
            </button>

            <img
              src={getLogoBySubdomain()} // Replace with your actual logo image URL
              alt="Banner Logo"
              className="h-[28px] cursor-pointer ml-4 md:hidden"
              onClick={() => navigate("/dashboard")}
            />
          </div>
          <div className="flex md:flex-row lg:flex-row flex-col lg:items-center items-end md:items-center md:w-[30%] lg:w-[30%] w-[50%] justify-end ">
            <p className="md:mr-3 mr-0 lg:mr-5 md:text-lg lg:text-lg text-base truncate md:w-full lg:w-full w-36 text-right">
              <b>{course?.title}</b>
            </p>

            {
              LearningStore.checkCourseEnrolled(course?._id) ? (
                <CourseProgress
                  availableCredits={LearningStore.getTheCourseCompletionPercentage(
                    course?._id
                  )}
                />
              ) : null
              // <div className="md:block lg:block hidden">
              //   <EnrollButton />
              // </div>
            }
          </div>
        </div>
      </header>
    );
  };
  const navigateToCertificate = () => {
    // if(window.innerWidth < 768){
    navigateToCourseCertificate();
    // }
    // else{
    // // navigate.push
    // navigate(`/dashboard/course/${LearningStore.currentCourse?._id}/certificate`);
    // setCollapse(true)
    // }
  };
  const navigateToCourseCertificate = () => {
    if (
      LearningStore.getTheCourseCompletionPercentage(
        LearningStore.currentCourse?._id
      ) > 99
    ) {
      const data = {
        name: UserStore.userDetails?.name,
        interviewTopic: LearningStore.currentCourse?.title,
        date: LearningStore.getCourseCompletionDate(
          LearningStore.currentCourseId
        ),
        autoDownload: true,
      };
      localStorage.setItem("certificate", JSON.stringify(data));
      const query = queryString.stringify(data);
      window.open(`/CourseCertificate?${query}`, "_blank");
    } else {
      alert("You have not completed the course yet");
    }
  };
  return (
    <>
      <Observer>
        {() => (
          <>
          {LearningStore.loading ? (
            <>
              <div className="loadingbox flex flex-row-reverse w-full h-screen max-md:flex-col">
                <div className="right w-[35%] max-md:w-[100%] max-md:h-[60vh]">
                  <LoadingAnime
                    numBoxes={1}
                    page={"learningTab"}
                    gridColumns="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-1"
                    boxHeight={"80vh"}
                    innerBoxes={[
                      {
                        width: "98%",
                        height: "45%",
                        color: "bg-gray-400",
                        shape: "rectangle",
                        top: "0rem",
                        left: "0.3rem",
                      },
                      {
                        width: "45%",
                        height: "5%",
                        color: "bg-gray-400",
                        shape: "rectangle",
                        top: "50%",
                        left: "0.3rem",
                      },
                      {
                        width: "35%",
                        height: "4%",
                        color: "bg-gray-400",
                        shape: "rectangle",
                        top: "59%",
                        left: "0.3rem",
                      },
                      {
                        width: "70%",
                        height: "4%",
                        color: "bg-gray-400",
                        shape: "rectangle",
                        top: "64%",
                        left: "0.3rem",
                      },
                      {
                        width: "45%",
                        height: "5%",
                        color: "bg-gray-400",
                        shape: "rectangle",
                        top: "69%",
                        left: "0.3rem",
                      },
                      {
                        width: "45%",
                        height: "5%",
                        color: "bg-gray-400",
                        shape: "rectangle",
                        top: "75%",
                        left: "0.3rem",
                      },
                      {
                        width: "30%",
                        height: "5%",
                        color: "bg-gray-400",
                        shape: "rectangle",
                        top: "50%",
                        right: "0.3rem",
                      },
                      {
                        width: "98%",
                        height: "10%",
                        color: "bg-gray-400",
                        shape: "rectangle",
                        bottom: "0.8rem",
                        right: "0rem",
                      },
                    ]}
                  />
                </div>
                <div className="left w-[65%] mt-[3rem] px-[3rem] max-md:w-[100%] ">
                  <div className="p-6 mx-auto bg-white rounded-xl shadow-md space-y-4 w-full h-full relative">
                    <div className="h-8 bg-gray-300 rounded w-1/4 animate-pulse"></div>
                    <div className="h-8 bg-gray-300 rounded w-[9rem] animate-pulse absolute top-1 right-2 mb-5"></div>
                    <div className="space-y-2 mt-12">
                      <div className="h-6 bg-gray-300 rounded w-3/4 animate-pulse"></div>
                      <div className="h-6 bg-gray-300 rounded w-5/6 animate-pulse"></div>
                      <div className="h-6 bg-gray-300 rounded w-2/3 animate-pulse"></div>
                      <div className="h-6 bg-gray-300 rounded w-full animate-pulse"></div>
                    </div>
                    <div className="space-y-4">
                      <div className="h-6 bg-gray-300 rounded w-1/3 animate-pulse"></div>
                      <div className="space-y-2">
                        <div className="h-5 bg-gray-300 rounded w-full animate-pulse"></div>
                        <div className="h-5 bg-gray-300 rounded w-5/6 animate-pulse"></div>
                        <div className="h-5 bg-gray-300 rounded w-2/3 animate-pulse"></div>
                        <div className="h-5 bg-gray-300 rounded w-3/4 animate-pulse"></div>
                      </div>
                      <div className="space-y-2">
                        <div className="h-5 bg-gray-300 rounded w-1/2 animate-pulse"></div>
                        <div className="h-5 bg-gray-300 rounded w-3/4 animate-pulse"></div>
                        <div className="h-5 bg-gray-300 rounded w-full animate-pulse"></div>
                        <div className="h-5 bg-gray-300 rounded w-2/3 animate-pulse"></div>
                      </div>
                    </div>
                    <div className="h-5 bg-gray-300 rounded w-1/4 animate-pulse"></div>
                  </div>
                </div>
              </div>
            </>) : (
              
              <div className="w-full h-screen">
              {header(LearningStore.currentCourse)}
              {/* <Loader loader={LearningStore?.loading} /> */}

              <div className="gil-reg w-full h-[92%] flex">
                {LearningStore.checkCourseEnrolled(
                  LearningStore.currentCourse?._id
                ) ? (
                  <Sidebar
                    onBackdropClick={() => setToggled(false)}
                    toggled={toggled}
                    collapsed={collapse}
                    breakPoint="md"
                    onBreakPoint={(value) => setonBreak(value)}
                    className="bg-white shadow-xl relative"
                  >
                    <button
                      className="font-bold text-center w-full mt-5 flex justify-between hover:bg-gray-100 py-3 px-5"
                      onClick={() => {
                        if (window.innerWidth < 768) {
                          navigate(
                            `/course/${LearningStore.currentCourse?._id}`
                          );
                        } else {
                          navigate(
                            `/dashboard/course/${LearningStore.currentCourse?._id}`
                          );
                        }
                        closeSideBar();
                      }}
                    >
                      Overview
                    </button>
                    <Menu className="flex flex-col justify-between ">
                      {LearningStore.topics.map((topic, index) => (
                        <SubMenu
                          label={topic?.title}
                          key={index}
                          className="gil-med"
                        >
                          {topic?.subTopics?.map((subTopic, index2) => (
                            <MenuItem
                              onClick={() => {
                                /* --------------------- Marking the topic as completed --------------------- */

                                if (
                                  !LearningStore.checkTopicCompleted(
                                    LearningStore?.currentCourse?._id,
                                    LearningStore?.currentSubTopic?._id
                                  ) // this method will tell if the topic is completed or not
                                ) {
                                  // LearningStore.completeCurrentSubTopic(
                                  //   LearningStore.currentSubTopic?._id
                                  // ); // this is the auto complete when the user clicks on the topic
                                }

                                /* ----------------------------------- xxx ---------------------------------- */

                                console.log("subTopic", subTopic?._id);
                                LearningStore.setCurrentSubTopicById(
                                  subTopic?._id
                                );
                                if (window.innerWidth < 768) {
                                  navigate(
                                    `/course/${LearningStore.currentCourse?._id}?topic=${subTopic?._id}`
                                  );
                                } else {
                                  navigate(
                                    `/dashboard/course/${LearningStore.currentCourse?._id}?topic=${subTopic?._id}`
                                  );
                                }

                                /* ----------------------------- close side menu ---------------------------- */
                                closeSideBar();
                                /* ----------------------------------- xxx ---------------------------------- */
                              }}
                              key={index2}
                              className="opacity-50 text-sm"
                            >
                              {" "}
                              {subTopic?.title}{" "}
                            </MenuItem>
                          ))}
                        </SubMenu>
                      ))}
                    </Menu>
                    <button
                      className="flex justify-around items-center mx-auto mt-10 mb-5 bg-primary text-white w-[80%] right-7 py-2 px-3 font-bold rounded-md gap-1"
                      onClick={() => navigateToCertificate()}
                    >
                      <MdDownload className="text-white" /> Course Certificate
                    </button>
                  </Sidebar>
                ) : null}
                <main className="w-full overflow-x-hidden">
                  {/* <div className="nav-bar row-auto  m-0 justify-between items-center">
                <div
                  className="col-auto cursor-pointer "
                  onClick={() => toggleCollapse()}
                >
                  {!collapse ? (
                    <MdOutlineKeyboardArrowLeft className="text-5xl " />
                  ) : (
                    <MdOutlineKeyboardArrowRight className="text-5xl" />
                  )}
                </div>
              </div> */}
                  <div>
                    <Routes className="router-parent">
                      <Route
                        path="/"
                        element={
                          isParamExist() ? <LearningModule /> : <EnrollCourse />
                        }
                      />

                      <Route
                        path="*"
                        element={
                          <div>
                            <h1>404</h1>
                          </div>
                        }
                      />

                      <Route
                        path="/certificate"
                        element={
                          LearningStore.getTheCourseCompletionPercentage(
                            LearningStore.currentCourse?._id
                          ) > 99 ? (
                            <div className="w-screen h-screen flex justify-center items-center">
                              <CourseCertificate
                                userName={UserStore.userDetails?.name}
                                issueDate={LearningStore.getCourseCompletionDate(
                                  LearningStore.currentCourseId
                                )}
                                courseTopic={LearningStore.currentCourse?.title}
                                autoDownload={false}
                              />
                              <button
                                className="flex justify-around items-center bg-primary text-white w-50 py-2 px-10 mt-5 font-bold rounded-md absolute top-14 left-24 z-50"
                                onClick={navigateToCourseCertificate}
                              >
                                <MdDownload className="text-white mx-2" />{" "}
                                Download certificate
                              </button>
                            </div>
                          ) : (
                            <div className="w-screen h-screen flex justify-center items-center">
                              <h1 className="text-4xl">
                                You didn't complete the course{" "}
                              </h1>
                            </div>
                          )
                        }
                      />
                    </Routes>
                  </div>
                </main>
              </div>
              <HelpCenter className="hidden lg:block md:block" />
              <HelpCenter
                className={"block lg:hidden md:hidden bottom-[8vh]"}
              />
            </div>
           
          
          
          )}
            
          </>
        )}
      </Observer>
    </>
  );

  function EnrollCourse() {
    const { LearningStore, PopupStore } = useStores();
    const redirectToSignupPageWithCurrentUrl = () => {
      const currentPath = window.location.href;

      // set currentPath in local storage
      setDataToLocalStorage("redirectUrl", currentPath);

      const signupUrl = `/signup`;

      console.log(signupUrl);

      navigate(signupUrl);
    };

    return (
      <>
        <Observer>
          {() => (
            <>
              {PopupStore.loginWarning && (
                <Popup
                  popUpInitialValue={PopupStore.loginWarning}
                  handlePopup={() => {
                    PopupStore.setLoginWarning(false);
                  }}
                  image={loginWarningImage}
                  content="Please signup to enroll course"
                  buttontext="Signup now"
                  onClick={() => {
                    redirectToSignupPageWithCurrentUrl();
                    PopupStore.setLoginWarning(false);
                  }}
                />
              )}
              <div className="bg-slate-100  min-h-screen flex md:flex-row-reverse lg:flex-row-reverse flex-col pt-[2%] w-[100%] relative">
                <div className="md:sticky md:top-[5%] lg:sticky lg:top-[5%] container mx-auto h-fit flex rounded-lg bg-bg3 md:w-[30%] lg:w-[30%] w-[90%] flex-col py-[2%]  p-4">
                  <CourseDetails
                    title={LearningStore.currentCourse?.title}
                    description={LearningStore.currentCourse?.description}
                    image={
                      LearningStore.currentCourse?.thumbnail ??
                      LearningStore.currentCourse?.image
                    }
                    courseId={LearningStore.currentCourse?._id}
                    noOfTopics={LearningStore.allSubTopics.length}
                  />
                </div>
                {/* <Loader loader={LearningStore?.loading} /> */}
                <div className="flex flex-col mx-auto h-fit md:mt-0 lg:mt-0 mt-6  md:w-[60%] lg:w-[60%] w-[90%] overflow-y-scroll no-scrollbar">
                  {/* <CourseBenefits />
                <CourseOutcomes /> */}
                  <TopicsList />
                </div>
              </div>
            </>
          )}
        </Observer>
      </>
    );
  }
}
export function EnrollButton() {
  const navigate = useNavigate();
  const { LearningStore, PopupStore, UserStore } = useStores();
  const enrollcourse = async (courseId) => {
    const resp = await LearningStore.enrollForCourse(courseId);
    if (resp) {
      alert("Enrolled Successfully");
    }
  };

  return (
    <Observer>
      {() => (
        <div>
          <button
            class="w-[100%] hover:bg-transparent bg-primary hover:text-primary font-semibold text-bg3 py-2 px-4 hover:border hover:border-primary border-transparent rounded-lg"
            onClick={() => {
              if (UserStore.userDetails?.name === undefined) {
                {
                  PopupStore.setLoginWarning(true);
                }
                console.log("Please log in to enroll.");
              } else {
                enrollcourse(LearningStore.currentCourseId);
              }
            }}
          >
            Enroll to start learning
          </button>
        </div>
      )}
    </Observer>
  );
}

export function CourseBenefits() {
  return (
    <div className="flex flex-col  h-fit w-full">
      <h1 className="text-base font-semibold">Benefits:</h1>
      {learnBenefits.map((item, index) => (
        <div key={index} className="flex flex-row  w-[95%] mx-auto">
          <span className="text-lg text-primary mr-1 ">
            <TiTick />{" "}
          </span>
          <p className="text-base">{item.description}</p>
        </div>
      ))}
    </div>
  );
}

export function CourseOutcomes() {
  const [showAll, setShowAll] = useState(false);
  const sentencesToShow = showAll ? courseOutcomes : courseOutcomes.slice(0, 3);

  const toggleShowAll = () => {
    setShowAll(!showAll);
  };

  return (
    <div className="flex flex-col h-fit  w-full">
      <h1 className="text-base font-semibold">Outcomes:</h1>
      {sentencesToShow.map((item, index) => (
        <div key={index} className="flex flex-row  w-[95%] mx-auto">
          <span className="text-base mr-1 ">{index + 1}. </span>
          <p className="text-base">{item}</p>
        </div>
      ))}
      {!showAll ? (
        <button
          className="text-primary w-[95%]  flex flex-row justify-end items-center text-base hover:underline"
          onClick={toggleShowAll}
        >
          Show More <BiChevronDownCircle className="ml-1 text-primary" />
        </button>
      ) : (
        <button
          className="text-primary  w-[95%] text-base  flex flex-row justify-end items-center hover:underline"
          onClick={toggleShowAll}
        >
          Show Less <BiChevronUpCircle className="ml-1 text-primary" />
        </button>
      )}
    </div>
  );
}

export function TopicsList() {
  const { LearningStore } = useStores();
  const [showAll, setShowAll] = useState(false);
  const topicsToShow = showAll
    ? LearningStore.topics
    : LearningStore.topics.slice(0, 3);
  const toggleShowAll = () => {
    setShowAll(!showAll);
  };
  return (
    <div className="flex flex-col h-fit  w-full">
      <span className="flex justify-between">
        <h1 className="text-base  ">
          Course:{" "}
          <span className="font-semibold">
            {LearningStore.currentCourse?.title}
          </span>{" "}
        </h1>
        <p className="text-base">
          Topics:{" "}
          <span className="font-semibold">
            {" "}
            {LearningStore.allSubTopics.length}
          </span>
        </p>
      </span>
      <p className="my-4 text-base ">
        <span className="font-bold"> Description :</span> <br />{" "}
        {LearningStore.currentCourse?.description}
      </p>
      <h1 className="text-base font-semibold">
        Topics you will cover in this course:
      </h1>
      {topicsToShow.map((topic, index) => (
        <div className="flex flex-col w-[95%] mx-auto">
          <div key={index} className="flex flex-row  w-full mx-auto">
            <span className="text-base mr-1 ">{index + 1}. </span>
            <p className="text-base">{topic.title}:</p>
          </div>
          <div className="flex flex-col w-[90%]">
            {topic.subTopics.map((subtopic, index2) => (
              <div
                key={index2}
                className="flex text-gray-400 flex-row  w-full mx-auto"
              >
                <span className="text-base  mr-1 ">
                  <BsDot />{" "}
                </span>
                <p className="text-base">{subtopic.title}</p>
              </div>
            ))}
          </div>
        </div>
      ))}
      {!showAll ? (
        <button
          className="text-primary w-[95%]  flex flex-row justify-end items-center text-base hover:underline"
          onClick={toggleShowAll}
        >
          Show More <BiChevronDownCircle className="ml-1 text-primary" />
        </button>
      ) : (
        <button
          className="text-primary  w-[95%] text-base  flex flex-row justify-end items-center hover:underline"
          onClick={toggleShowAll}
        >
          Show Less <BiChevronUpCircle className="ml-1 text-primary" />
        </button>
      )}
    </div>
  );
}
export function CourseDetails({
  title,
  description,
  image,
  courseId,
  noOfTopics,
}) {
  const { LearningStore } = useStores();
  const [expanded, setExpanded] = useState(false);

  const truncatedDescription = description?.slice(0, 100);
  const navigate = useNavigate();

  const toggleDescription = () => {
    setExpanded(!expanded);
  };

  const goToLearnPage = () => {
    navigate("/dashboard/learn");
  };

  const continueLearning = () => {
    const lastCompletedTopic =
      LearningStore.getTheLastCompletedSubTopic(courseId);
    if (!lastCompletedTopic) return;
    console.log("lastCompletedTopic", toJS(lastCompletedTopic));
    navigate(`/course/${courseId}?topic=${lastCompletedTopic?._id}`);
  };

  useEffect(() => {
    // continueLearning();
    return () => {
      console.log("unmounting");
    };
  }, []);

  return (
    <>
      {/* Embedded YouTube video */}

      <div className="flex justify-center items-center">
        <img
          src={`${image}`}
          className="object-cover md:w-[100%]  md:h-[30vh] border-2 border-primary w-[90vw] h-[20vh] rounded-[15px] lg:w-[100%] lg:h-[40vh]"
        />
      </div>
      {/* <div className="md:w-[360px] md:h-[360px] rounded-[15px] border-2 border-primary">
                  <img
                    src={`${image}`}
                    className="md:w-full md:h-full border-2 border-primary w-[90vw] h-[30vh] rounded-[15px] lg:w-[1260px] lg:h-[815px]"
                  />
                </div> */}

      <div className="ml-[4%]  w-[90%] flex flex-col  justify-center ">
        <div className="flex justify-between mt-6 md:mt-4 lg:mt-4 mb-4">
          <h1 className="text-base  ">
            Course Name: <span className="font-semibold">{title}</span>{" "}
          </h1>
          <p className="text-base">
            Topics: <span className="font-semibold"> {noOfTopics ?? ""}</span>
          </p>
        </div>
        {expanded ? (
          <>
            <p className="my-4 text-base">
              Course Description: <br /> {description}
            </p>
            <button
              className="text-primary  w-[95%] text-base  flex flex-row justify-end items-center hover:underline mb-[4%]"
              onClick={toggleDescription}
            >
              Show Less <BiChevronUpCircle className="ml-1 text-primary" />
            </button>
          </>
        ) : (
          <>
            <p className="my-4 text-base">
              Course Description: <br /> {truncatedDescription}...
            </p>
            <button
              className="text-primary  w-[95%] text-base  flex flex-row justify-end items-center hover:underline mb-[4%]"
              onClick={toggleDescription}
            >
              Show More <BiChevronDownCircle className="ml-1 text-primary" />
            </button>
          </>
        )}

        {/* Navigation buttons */}

        {/* <div className="flex flex-row justify-center mx-auto items-center w-[115%] "> */}
        {/* <button className="flex flex-row items-center justify-center hover:border-b-2 hover:border-primary text-primary " onClick={goToLearnPage}>
            <IoChevronBackCircleOutline className="mr-1" /> Back
          </button> */}

        {/* <div className="flex justify-between items-center  "> */}
        <>
          {LearningStore.checkCourseEnrolled(courseId) ? (
            <div
              className="w-[100%] bg-green-100 border-l-4 border-green-500 text-text_color3 py-2 px-4"
              role="success"
            >
              <p class="font-bold">
                You have enrolled for this course, Start learning
              </p>
            </div>
          ) : (
            <EnrollButton />
          )}

          {LearningStore.checkCourseEnrolled(courseId) ? (
            <button
              onClick={() => {
                const lastCompletedTopic =
                  LearningStore.getTheLastCompletedSubTopic(courseId);
                console.log("lastCompletedTopic", toJS(lastCompletedTopic));
                LearningStore.setCurrentSubTopicById(
                  lastCompletedTopic?.topicId ?? lastCompletedTopic?._id
                );
                if (window.innerWidth < 768) {
                  navigate(
                    `/course/${courseId}?topic=${
                      lastCompletedTopic?.topicId ?? lastCompletedTopic?._id
                    }`
                  );
                } else {
                  navigate(
                    `/dashboard/course/${courseId}?topic=${
                      lastCompletedTopic?.topicId ?? lastCompletedTopic?._id
                    }`
                  );
                }
              }}
              className="my-2 hover:bg-transparent bg-primary hover:text-primary font-semibold  text-bg3 py-2 px-4 hover:border hover:border-primary border-transparent rounded-lg"
            >
              Start learning
            </button>
          ) : null}
        </>
        {/* </div> */}
        {/* </div> */}
      </div>
    </>
  );
}
